import React, { Component } from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
//import Form from '../../components/forms/RequestFormAdding';
import { newRequest, withRedirect } from "../../CroActions";
import { breadcrumbs } from "../../../../actions/appActions";
import { noop } from "lodash";

const selector = formValueSelector("requestForm");

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: "Žádost o nahlížení na neveřejné oznámení" }],
  aifo: selector(state, "person.aifo"),
  legalPerson: selector(state, "legalPerson"),
  officials: selector(state, "officials") || [],
  attachments: selector(state, "attachments") || [],
  isNew: true,
  rejectText: selector(state, "rejectText"),
  text: selector(state, "text"),
});

const onSubmit = withRedirect(newRequest, "/verejnost");

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ onSubmit, breadcrumbs }, dispatch),
  accept: noop,
  reject: noop,
  dispatch,
});

class Form extends Component {
  componentWillMount() {
    const { breadcrumbs, breadcrumbsItems } = this.props;
    breadcrumbs(breadcrumbsItems);
  }

  render() {
    return (
      <div className="publicPage">
        <div className="publicPage__card publicPage__card--wideText">
          <div className="publicPage__header">
            <div className="publicPage__title">
              Žádost o nahlížení na neveřejné oznámení
            </div>
            <div className="publicPage__subtitle">
              Informace k podání žádosti a rozsahu zpřístupněných údajů.
            </div>
          </div>

          <div className="publicPage__content publicContent">
            <p>
              <b>
                <u>Kdo může nahlížet do Centrálního registru oznámení?</u>
              </b>
            </p>

            <p>
              Každý má právo bezplatně nahlížet prostřednictvím veřejné datové
              sítě a v rozsahu stanoveném zákonem do registru oznámení. Oznámení
              veřejných funkcionářů jsou veřejnosti přístupná pouze na základě
              žádosti.
            </p>

            <p>
              <b>
                Oznámení veřejných funkcionářů z řad soudců, státních zástupců,
                příslušníků Policie České republiky a příslušníků Generální
                inspekce bezpečnostních sborů veřejně přístupná nejsou a
                nahlížet na ně nelze.
              </b>{" "}
              Údaje obsažené v oznámeních těchto veřejných funkcionářů se
              veřejnosti neposkytují ani podle zákona č. 106/1999 Sb., o
              svobodném přístupu k informacím, ve znění pozdějších předpisů.
            </p>

            <p>
              Veškeré údaje vedené v registru oznámení týkající se veřejných
              funkcionářů mohou být použity a dále zpracovávány pouze za účelem
              zjištění případného porušení povinností veřejného funkcionáře.
            </p>

            <p>
              <b>
                <u>Na co všechno se budu moci po podání žádosti podívat?</u>
              </b>
            </p>

            <p>
              <u>Ve vztahu k veřejným funkcionářům podle § 2 odst. 1</u>
            </p>

            <p>
              1. u veřejných funkcionářů podle § 2 odst. 1 písm. a) až p) a u
              členů rady kraje nebo hlavního města Prahy, kteří nejsou pro výkon
              funkce dlouhodobě uvolněni - <b>přístupné</b> jsou všechny uvedené
              skutečnosti oznámené podle § 9 až 11 a § 12 odst. 4 → tj.{" "}
              <b>
                oznámení o činnostech, majetku (nemovitosti, cenné papíry,
                podíly v obchodních korporacích, jiné věci movité určené podle
                druhu), příjmech a závazcích.
              </b>
            </p>

            <p>
              2. u veřejných funkcionářů podle § 2 odst. 1 písm. q) a u
              primátora a náměstka primátora statutárního města, starosty
              městské části nebo městského obvodu územně členěného statutárního
              města nebo městské části hlavního města Prahy, místostarosty
              městské části nebo městského obvodu územně členěného statutárního
              města, zástupce starosty městské části hlavního města Prahy a
              členů rady statutárního města, městské části nebo městského obvodu
              územně členěného statutárního města a městské části hlavního města
              Prahy, kteří nejsou pro výkon funkce dlouhodobě uvolněni -{" "}
              <b>přístupné</b> jsou uvedené skutečnosti oznámené podle § 9, § 10
              odst. 2 písm. a) až c), a § 11 odst. 2 písm. a) a § 12 odst. 4 →
              tj.{" "}
              <b>
                oznámení o činnostech, majetku (pouze nemovitosti, cenné papíry
                a podíly v obchodních korporacích), příjmech. Jinými slovy{" "}
                <b>
                  <u>nejsou</u>
                </b>
                viditelné údaje o jiných věcech movitých určených podle druhu a
                oznámení o závazcích.
              </b>
            </p>

            <p>
              3. u veřejných funkcionářů podle § 2 odst. 1 písm. r), s výjimkou
              primátora a náměstka primátora statutárního města, starosty
              městské části nebo městského obvodu územně členěného statutárního
              města nebo městské části hlavního města Prahy, místostarosty
              městské části nebo městského obvodu územně členěného statutárního
              města, zástupce starosty městské části hlavního města Prahy a
              členů rady statutárního města, městské části nebo městského obvodu
              územně členěného statutárního města, městské části hlavního města
              Prahy, kraje nebo hlavního města Prahy - <b>přístupné</b> jsou
              uvedené skutečnosti oznámené podle § 9, § 10 odst. 2 písm. a) až
              c) a § 12 odst. 4 → tj.{" "}
              <b>
                oznámení o činnostech, majetku (pouze nemovitosti, cenné papíry,
                podíly v obchodních korporacích). Jinými slovy <u>nejsou</u>{" "}
                viditelné údaje o jiných věcech movitých určených podle druhu a
                údaje z oznámení o příjmech a závazcích.
              </b>
            </p>

            <p>
              <u>Ve vztahu k veřejným funkcionářům podle § 2 odst. 2</u>
            </p>

            <p>
              U veřejných funkcionářů podle § 2 odst. 2 zákona o střetu zájmů
              (sem patří např. voják z povolání, ředitel veřejné výzkumné
              instituce, vedoucí úředník územně samosprávných celků, vedoucí
              zaměstnanci organizačních složek státu, státních příspěvkových
              organizací, člen statutárního, dozorčího, řídícího či kontrolního
              orgánu právnické osoby zřízených státem) jsou dostupné skutečnosti
              oznámené podle § 9, § 10 odst. 2 písm. a) a c), § 11 odst. 2 písm.
              a) → tj.{" "}
              <b>
                oznámení o činnostech, majetku (pouze nemovitosti a podíly v
                obchodních korporacích) a příjmech. Jinými slovy <u>nejsou</u>{" "}
                viditelné údaje o cenných papírech, jiných věcech movitých
                určených podle druhu a oznámení o závazcích
              </b>
            </p>

            <p>
              <b>
                Oznámení veřejných funkcionářů z řad soudců, státních zástupců,
                příslušníků Policie České republiky a příslušníků Generální
                inspekce bezpečnostních sborů veřejně přístupná nejsou a
                nahlížet na ně nelze.
              </b>{" "}
              Údaje obsažené v oznámeních těchto veřejných funkcionářů se
              veřejnosti neposkytují ani podle zákona č. 106/1999 Sb., o
              svobodném přístupu k informacím, ve znění pozdějších předpisů.
            </p>

            <p>
              <u>
                <b>
                  Komu podávám žádost o nahlížení na oznámení veřejných
                  funkcionářů?
                </b>
              </u>
            </p>

            <p>Žádost podáváte:</p>

            <ul>
              <li>
                písemně na listině s Vaším úředně ověřeným podpisem Ministerstvu
                spravedlnosti ČR, Odbor střetu zájmů a boje proti korupci,
                Vyšehradská 16, 128 10 Praha 2,
              </li>
              <li>
                elektronicky prostřednictvím elektronické adresy podatelny
                správce registru oznámení, tedy na e-mail{" "}
                <a href="mailto:posta@msp.gov.cz">posta@msp.gov.cz</a> zprávou
                opatřenou uznávaným elektronickým podpisem ve smyslu § 6 odst. 1
                a 2 zákona č. 297/2016 Sb., o službách vytvářejících důvěru pro
                elektronické transakce, nebo
              </li>
              <li>doručením přes Vaší datovou schránku - kq4aawz.</li>
            </ul>

            <p>
              <u>
                <b>Co musí žádost o nahlížení obsahovat?</b>
              </u>
            </p>

            <p>
              <b>Jsem-li fyzická osoba:</b>
            </p>

            <p>jméno, popřípadě jména, příjmení,</p>

            <p>datum narození,</p>

            <p>trvalý pobyt a adresu pro doručování žadatele</p>

            <p>
              <b>Jsem-li právnická osoba:</b>
            </p>

            <p>obchodní firma nebo název,</p>

            <p>identifikační číslo osoby</p>

            <p>sídlo,</p>

            <p>
              údaje o fyzické osobě, která jedná v zastoupení právnické osoby, a
              její oprávnění jednat v zastoupení právnické osoby.
            </p>

            <p>
              Dále musí obsahovat jméno, popřípadě jména a příjmení veřejného
              funkcionáře, nebo funkci veřejného funkcionáře a právnickou osobu
              nebo její orgán nebo organizační složku, ve které veřejný
              funkcionář působí.
            </p>

            <p>
              <u>
                <b>
                  Jaký je vztah ustanovení upravujících podání žádosti o
                  nahlížení na oznámení veřejných funkcionářů zákona o střetu
                  zájmů k zákonu o svobodném přístupu k informacím?
                </b>
              </u>
            </p>

            <p>
              Ustanovení upravující podání žádosti o nahlížení na oznámení
              veřejných funkcionářů podle zákona o střetu zájmů (§ 13 odst. 3 až
              5 zákona o střetu zájmů) jsou ve vztahu speciality k zákonu o
              svobodném přístupu k informacím, a proto se na případy nahlížení
              na oznámení těchto veřejných funkcionářů podaná podle zákona o
              střetu zájmů nepoužije.
            </p>

            <p>
              <u>
                <b>Jak bude žádost vyřízena?</b>
              </u>
            </p>

            <p>
              Vaši žádost ověří Ministerstvo spravedlnosti a na základě toho Vám
              vygeneruje přihlašovací jméno a heslo, kterým se budete moci
              přihlásit do Centrálního registru oznámení (
              <a href="https://cro.justice.cz/prihlaseni/verejnost">zde</a>),
              kde se Vám zpřístupní příslušná oznámení, o které jste žádal. Tyto
              údaje Vám budou doručeny do 30 dnů ode dne obdržení žádosti, a to
              na adresu pro doručování uvedenou v žádosti. K přihlášení budete
              moci využít také jeden z prostředků elektronické identifikace
              (Identita občana).
            </p>

            <p>
              <u>
                <b>Jak dlouho budou přihlašovací údaje aktivní?</b>
              </u>
            </p>

            <p>
              Přihlašovací jméno a přístupové heslo do Centrálního registru
              oznámení je platné po dobu 6 měsíců ode dne jejich prvního
              použití.
            </p>

            <p>
              POZOR: Sdělit třetí osobě přístupové jméno a heslo k nahlížení do
              Centrálního registru oznámení je zakázáno.
            </p>

            <p>
              <u>
                <b>Mohu nahlížet do oznámení soudců nebo policistů?</b>
              </u>
            </p>

            <p>
              Ne. Oznámení veřejných funkcionářů z řad soudců, státních
              zástupců, příslušníků Policie ČR a příslušníků Generální inspekce
              bezpečnostních sborů nejsou veřejně přístupná a údaje z těchto
              oznámení se veřejnosti neposkytují ani podle zákona č. 106/1999
              Sb., o svobodném přístupu k informacím, ve znění pozdějších
              předpisů.
            </p>

            <p>
              <u>
                <b>
                  Mohu nahlížet i do oznámení, která nejsou v Centrálním
                  registru oznámení, tj. ty, které byly podané do 31. srpna
                  2017?
                </b>
              </u>
            </p>

            <p>
              Ne. Oznámení veřejných funkcionářů a žádosti o nahlížení na tato
              oznámení podané do 31. srpna 2017 byly uchovávány u předchozího
              evidenčního orgánu v listinné podobě, a to po dobu pěti let od
              nabytí účinnosti zákona č. 14/2017 Sb., tj. do 1. září 2022.
            </p>

            <p>
              Po uplynutí této zákonem stanovené doby měly předchozí evidenční
              orgány s listinnými dokumenty naložit dle příslušných ustanovení
              zákona č. 499/2004 Sb., o archivnictví a spisové službě, ve znění
              pozdějších předpisů (typicky mělo dojít k jejich skartaci).
            </p>

            <p>
              <u>
                <b>
                  Budou se oznámení podaná do 31. srpna 2017 hromadně nahrávat
                  do Centrálního registru oznámení?
                </b>
              </u>
            </p>

            <p>
              Ne, s tímto hromadným přesunem oznámení a žádostí o nahlížení se
              nepočítá.
            </p>

            <p>
              <u>
                <b>
                  Dozví se veřejný funkcionář, kdo žádá o nahlížení na jeho
                  oznámení?&nbsp;
                </b>
              </u>
            </p>

            <p>
              Veřejný funkcionář má nárok (pokud o to požádá) na veškeré
              informace o žadateli, kterými Ministerstvo spravedlnosti
              disponuje, tzn. veškeré informace, které žadatel do žádosti uvedl.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form);
